import React, { Component } from 'react'
import { GET_POE } from '../store/actions/types'
import { getPoe } from '../store/actions/freshCardActions'
import { connect } from 'react-redux'
import MUIDataTable from 'mui-datatables'
import {
  createTheme,
  MuiThemeProvider,
  getMuiTheme,
  withStyles
} from '@material-ui/core/styles'
import {
  isMobile,
  isBrowser
} from 'react-device-detect'

class Poe extends Component {
  constructor(props) {
    super(props)
  }
state = {
  userID: this.props.location.state.Everyone,
  currentLc: null
};

  // Safely format LC values for display (avoid floating point artifacts)
  formatLc = (value, decimals = 3) => {
    const num = Number(value)
    if (!isFinite(num)) return value || ''
    return num.toFixed(decimals)
  }

  componentDidMount() {
    const { getPoe } = this.props
    console.log('uid is: ', this.props.userdata);

    this.unsubscribe = this.props.getPoe({
      userID: this.state.userID,
      orderChild: 'userID'
    })
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe()
  }

// fetchCurrentLc = () => {
//   const { userID } = this.state;

//   firebase.database()
//     .ref(`user/${userID}/points`)
//     .once('value')
//     .then(snapshot => {
//       const points = snapshot.val();

//       console.log('Firebase userID:', userID);
//       console.log('Firebase points:', points);

//       this.setState({
//         currentLc: points !== null && points !== undefined
//           ? Number(points) / 100
//           : null
//       });
//     })
//     .catch(error => {
//       console.error('Error fetching current LC:', error);
//     });
// };

  columns = ['No', 'Asset/Action', 'Category', 'Action', 'Action Date', 'Gas', 'CurrLc', 'Quantity']

  options={
    selectableRows: false,
    textLabels: {
      body: {
        noMatch: isMobile ? '...' : 'Sorry no result...'
      }
    }
  }

  timeConverter = (UNIX_timestamp) => {
    let a = new Date(UNIX_timestamp)
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    let year = a.getFullYear()
    // var month = months[a.getMonth()];
    let month = a.getMonth()
    month = month + 1

    let date = a.getDate()
    let vdate = date.toString()
    let vmonth = month.toString()
    let vvdate
    let vvmonth
    // ///////////////////
    if (vdate.length === 1) {
      var s = '0' + date
      vvdate = s.substr(s.length - 2)
    } else {
      vvdate = vdate
    }
    // /////////////////////////
    if (vmonth.length === 1) {
      var s = '0' + month
      vvmonth = s.substr(s.length - 2)
    } else {
      vvmonth = month
    }
    // //////////////////
    // vdate = (Math.round(date * 100) / 100).toFixed(2);
    let hour = a.getHours()
    let min = a.getMinutes()
    let sec = a.getSeconds()
    // var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
    let time = year + '/' + vvmonth + '/' + vvdate
    return time
  }

// Works in both browser (React) and Node.js — just make sure moment-timezone is imported
// import moment from 'moment-timezone';
// or
// const moment = require('moment-timezone');

normalizeDateToIdealFormat = (input) => {
  // Handle null / undefined / empty
  if (!input || input === '' || input === null) {
    return null; // or '' or throw new Error('Missing date') — decide based on your needs
  }

  // If it's already a number → assume Unix timestamp (ms)
  if (typeof input === 'number') {
    return moment(input).tz('Africa/Johannesburg').format('YYYY-MM-DD HH:mm');
  }

  // If it's already a Date object
  if (input instanceof Date && !isNaN(input)) {
    return moment(input).tz('Africa/Johannesburg').format('YYYY-MM-DD HH:mm');
  }

  // String → try to parse
  if (typeof input === 'string') {
    // Order is important: most specific / most likely formats first
    // Add more patterns from your actual legacy data
    const knownFormats = [
      'YYYY-MM-DD HH:mm',          // your ideal format (fast path)
      'YYYY-MM-DD HH:mm:ss',
      'YYYY-MM-DD HH:mm:ss.SSS',
      'YYYY/MM/DD HH:mm',
      'YYYY/MM/DD',
      'DD/MM/YYYY HH:mm',          // very common in South Africa / UK / many countries
      'DD/MM/YYYY',
      'DD-MM-YYYY HH:mm',
      'DD-MM-YYYY',
      'MM/DD/YYYY HH:mm',          // US style — put after DD/MM if your data is mostly non-US
      'MM/DD/YYYY',
      'MMMM D, YYYY h:mm A',       // "February 12, 2026 4:45 PM"
      'MMMM D, YYYY',              // date only → will become 00:00
      moment.ISO_8601,             // handles ISO strings (with or without Z / offset)
    ];

    // Try strict parsing with known formats
    let m = moment(input, knownFormats, true); // true = strict mode

    // If strict failed → fallback to loose guess (less safe, but catches more junk)
    if (!m.isValid()) {
      m = moment(input); // forgiving mode
    }

    if (m.isValid()) {
      // Always convert to Johannesburg time and format exactly as wanted
      return m.tz('Africa/Johannesburg').format('YYYY-MM-DD HH:mm');
    }
  }

  // If we reach here → parsing failed
  console.warn(`Could not normalize date: ${input}`);
  return null; // or 'Invalid date' or throw — your choice
};
  
  transformTableData = () => {
    let { classes, userdata, getAllCompanyUsers, poe } = this.props;
    let nr;
    console.log('white dataListClone poe ', poe);

    if (poe && poe.length > 0) {  // Assuming poe is now an array
      // No need for initial sort if already sorted from getPoe, but re-sort to be sure (descending by fdate)
      const sortedPoe = [...poe].sort((a, b) => new Date(b.fdate || '1970-01-01') - new Date(a.fdate || '1970-01-01'));

      // Group 'Like received', etc., by date (as before, for compaction/performance)
      const groupedActions = {
        'Like received': {},
        'Like given': {},
        'Comment received': {},
        'Comment given': {}
      };
      const otherEntries = [];
      const processedTrailIDs = new Set();

      sortedPoe.forEach((entry, index) => {
        console.log(`Entry ${index} - fdate:`, entry.fdate, 'type:', typeof entry.fdate, 'value:', JSON.stringify(entry));
        if (processedTrailIDs.has(entry.trailID)) return;
        processedTrailIDs.add(entry.trailID);

        const parsedDate = new Date(entry.fdate || '1970-01-01');
        const dateOnly = parsedDate.toISOString().split('T')[0];  // Standardized date extraction

        if (!dateOnly || isNaN(parsedDate)) {
          console.warn(`Invalid fdate for entry ${index}:`, entry.fdate);
          return;  // Skip invalid entries for accuracy
        }

        if (['Like received', 'Like given', 'Comment received', 'Comment given'].includes(entry.actionType)) {
          const actionKey = entry.actionType;
          if (!groupedActions[actionKey][dateOnly]) {
            groupedActions[actionKey][dateOnly] = {
              entries: [],
              totalPoints: 0,
              latestEntry: entry,
              latestTime: parsedDate
            };
          }
          groupedActions[actionKey][dateOnly].entries.push(entry);
          groupedActions[actionKey][dateOnly].totalPoints += parseFloat(entry.pointsAdded || 0);
          if (parsedDate > groupedActions[actionKey][dateOnly].latestTime) {
            groupedActions[actionKey][dateOnly].latestEntry = entry;
            groupedActions[actionKey][dateOnly].latestTime = parsedDate
          }
        } else {
          otherEntries.push({ ...entry, parsedDate });
        }
      });

      // Build final array with groups and others
      const fpoeArray = [];

      ['Like received', 'Like given', 'Comment received', 'Comment given'].forEach(actionKey => {
        Object.entries(groupedActions[actionKey]).sort(([,a], [,b]) => b.latestTime - a.latestTime).forEach(([, group]) => {
          fpoeArray.push({
            ...group.latestEntry,
            actionType: actionKey === 'Like received' ? 'Likes received' : 
                        actionKey === 'Like given' ? 'Likes given' : 
                        actionKey === 'Comment received' ? 'Comments received' : 'Comments given',
            actionDesc: actionKey === 'Like received' || actionKey === 'Like given' ? 'Compiled Likes' : 'Compiled Comments',
            pointsAdded: group.totalPoints.toFixed(4),
            fdate: group.latestEntry.fdate  // Keep full fdate for display
          });
        });
      });

      fpoeArray.push(...otherEntries);

      // Final sort if needed (but groups and others are already time-sorted)
      fpoeArray.sort((a, b) => new Date(b.fdate || '1970-01-01') - new Date(a.fdate || '1970-01-01'));

      let dataListClone = fpoeArray.map((entry, index) => {
        console.log('green dataListClone 2 ', entry.firstName);
        nr = index + 1;
        return [
          nr,
          entry.actionType ? entry.actionType : '',
          entry.actionDesc ? entry.actionDesc.substring(0, 12) : '',
          entry.title ? entry.title.substring(0, 12) : '',
         // entry.fdate ? this.timeConverter(entry.fdate) : '',
          entry.fdate ? this.normalizeDateToIdealFormat(entry.fdate) : '',
          entry.gas ? this.formatLc(entry.gas) : '',
          //entry.pointsCurrent ? this.formatLc(entry.pointsCurrent) : '',
          entry.pointsCurrent ? this.formatLc(entry.pointsCurrent) : '',
          entry.pointsAdded ? this.formatLc(entry.pointsAdded, 4) : ''
        ];
      });
      console.log('green dataListClone 3 ', dataListClone);
      return dataListClone;
    }
    return [];
  };

  render() {
    const { poe } = this.props
    const getMuiTheme = () =>
    createTheme({
        overrides: {
          MuiChip: {
            root: {
              backgroundColor: '#000000'
            }
          }
        }
      })

    return (
      <div>
        <div><h3>Portfolio of Evidence</h3></div>
        {/* {this.props.poe ? */}
        <MuiThemeProvider theme={getMuiTheme()}>
          <MUIDataTable
            title={''}
            data={this.transformTableData()}
            columns={this.columns}
            options={this.options}
          // style={{id: "matrix"}}
          />
        </MuiThemeProvider>
        {/* : null} */}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    userdata: state.userDialog.userDetails[0],
    poe: state.poe.poe
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getPoe: params => dispatch(getPoe(params))
    // showToast: params => dispatch(showToast(params))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Poe)
////////////////////////////////////////////////////////////////////////////////////////////
// import React, { Component } from 'react'
// import { GET_POE } from '../store/actions/types'
// import { getPoe } from '../store/actions/freshCardActions'
// import { connect } from 'react-redux'
// import MUIDataTable from 'mui-datatables'
// import {
//   createTheme,
//   MuiThemeProvider,
//   getMuiTheme,
//   withStyles
// } from '@material-ui/core/styles'
// import {
//   isMobile,
//   isBrowser
// } from 'react-device-detect'

// class Poe extends Component {
//   constructor(props) {
//     super(props)
//   }
//   state = {
//     userID: this.props.location.state.Everyone
//   };

//   // Safely format LC values for display (avoid floating point artifacts)
//   formatLc = (value, decimals = 3) => {
//     const num = Number(value)
//     if (!isFinite(num)) return value || ''
//     return num.toFixed(decimals)
//   }

//   componentDidMount() {
//     const { getPoe } = this.props
//     this.unsubscribe = this.props.getPoe({
//       userID: this.state.userID,
//       orderChild: 'userID'
//     })
//   }

//   componentWillUnmount() {
//     if (this.unsubscribe) this.unsubscribe()
//   }

//   columns = ['No', 'Asset/Action', 'Category', 'Action', 'Action Date', 'Gas', 'CurrLc', 'Quantity']

//   options={
//     selectableRows: false,
//     textLabels: {
//       body: {
//         noMatch: isMobile ? '...' : 'Sorry no result...'
//       }
//     }
//   }

//   timeConverter = (UNIX_timestamp) => {
//     let a = new Date(UNIX_timestamp)
//     let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
//     let year = a.getFullYear()
//     // var month = months[a.getMonth()];
//     let month = a.getMonth()
//     month = month + 1

//     let date = a.getDate()
//     let vdate = date.toString()
//     let vmonth = month.toString()
//     let vvdate
//     let vvmonth
//     // ///////////////////
//     if (vdate.length === 1) {
//       var s = '0' + date
//       vvdate = s.substr(s.length - 2)
//     } else {
//       vvdate = vdate
//     }
//     // /////////////////////////
//     if (vmonth.length === 1) {
//       var s = '0' + month
//       vvmonth = s.substr(s.length - 2)
//     } else {
//       vvmonth = month
//     }
//     // //////////////////
//     // vdate = (Math.round(date * 100) / 100).toFixed(2);
//     let hour = a.getHours()
//     let min = a.getMinutes()
//     let sec = a.getSeconds()
//     // var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
//     let time = year + '/' + vvmonth + '/' + vvdate
//     return time
//   }

// // Works in both browser (React) and Node.js — just make sure moment-timezone is imported
// // import moment from 'moment-timezone';
// // or
// // const moment = require('moment-timezone');

// normalizeDateToIdealFormat = (input) => {
//   // Handle null / undefined / empty
//   if (!input || input === '' || input === null) {
//     return null; // or '' or throw new Error('Missing date') — decide based on your needs
//   }

//   // If it's already a number → assume Unix timestamp (ms)
//   if (typeof input === 'number') {
//     return moment(input).tz('Africa/Johannesburg').format('YYYY-MM-DD HH:mm');
//   }

//   // If it's already a Date object
//   if (input instanceof Date && !isNaN(input)) {
//     return moment(input).tz('Africa/Johannesburg').format('YYYY-MM-DD HH:mm');
//   }

//   // String → try to parse
//   if (typeof input === 'string') {
//     // Order is important: most specific / most likely formats first
//     // Add more patterns from your actual legacy data
//     const knownFormats = [
//       'YYYY-MM-DD HH:mm',          // your ideal format (fast path)
//       'YYYY-MM-DD HH:mm:ss',
//       'YYYY-MM-DD HH:mm:ss.SSS',
//       'YYYY/MM/DD HH:mm',
//       'YYYY/MM/DD',
//       'DD/MM/YYYY HH:mm',          // very common in South Africa / UK / many countries
//       'DD/MM/YYYY',
//       'DD-MM-YYYY HH:mm',
//       'DD-MM-YYYY',
//       'MM/DD/YYYY HH:mm',          // US style — put after DD/MM if your data is mostly non-US
//       'MM/DD/YYYY',
//       'MMMM D, YYYY h:mm A',       // "February 12, 2026 4:45 PM"
//       'MMMM D, YYYY',              // date only → will become 00:00
//       moment.ISO_8601,             // handles ISO strings (with or without Z / offset)
//     ];

//     // Try strict parsing with known formats
//     let m = moment(input, knownFormats, true); // true = strict mode

//     // If strict failed → fallback to loose guess (less safe, but catches more junk)
//     if (!m.isValid()) {
//       m = moment(input); // forgiving mode
//     }

//     if (m.isValid()) {
//       // Always convert to Johannesburg time and format exactly as wanted
//       return m.tz('Africa/Johannesburg').format('YYYY-MM-DD HH:mm');
//     }
//   }

//   // If we reach here → parsing failed
//   console.warn(`Could not normalize date: ${input}`);
//   return null; // or 'Invalid date' or throw — your choice
// };
  
//   transformTableData = () => {
//     let { classes, userdata, getAllCompanyUsers, poe } = this.props;
//     let nr;
//     console.log('white dataListClone poe ', poe);

//     if (poe && poe.length > 0) {  // Assuming poe is now an array
//       // No need for initial sort if already sorted from getPoe, but re-sort to be sure (descending by fdate)
//       const sortedPoe = [...poe].sort((a, b) => new Date(b.fdate || '1970-01-01') - new Date(a.fdate || '1970-01-01'));

//       // Group 'Like received', etc., by date (as before, for compaction/performance)
//       const groupedActions = {
//         'Like received': {},
//         'Like given': {},
//         'Comment received': {},
//         'Comment given': {}
//       };
//       const otherEntries = [];
//       const processedTrailIDs = new Set();

//       sortedPoe.forEach((entry, index) => {
//         console.log(`Entry ${index} - fdate:`, entry.fdate, 'type:', typeof entry.fdate, 'value:', JSON.stringify(entry));
//         if (processedTrailIDs.has(entry.trailID)) return;
//         processedTrailIDs.add(entry.trailID);

//         const parsedDate = new Date(entry.fdate || '1970-01-01');
//         const dateOnly = parsedDate.toISOString().split('T')[0];  // Standardized date extraction

//         if (!dateOnly || isNaN(parsedDate)) {
//           console.warn(`Invalid fdate for entry ${index}:`, entry.fdate);
//           return;  // Skip invalid entries for accuracy
//         }

//         if (['Like received', 'Like given', 'Comment received', 'Comment given'].includes(entry.actionType)) {
//           const actionKey = entry.actionType;
//           if (!groupedActions[actionKey][dateOnly]) {
//             groupedActions[actionKey][dateOnly] = {
//               entries: [],
//               totalPoints: 0,
//               latestEntry: entry,
//               latestTime: parsedDate
//             };
//           }
//           groupedActions[actionKey][dateOnly].entries.push(entry);
//           groupedActions[actionKey][dateOnly].totalPoints += parseFloat(entry.pointsAdded || 0);
//           if (parsedDate > groupedActions[actionKey][dateOnly].latestTime) {
//             groupedActions[actionKey][dateOnly].latestEntry = entry;
//             groupedActions[actionKey][dateOnly].latestTime = parsedDate
//           }
//         } else {
//           otherEntries.push({ ...entry, parsedDate });
//         }
//       });

//       // Build final array with groups and others
//       const fpoeArray = [];

//       ['Like received', 'Like given', 'Comment received', 'Comment given'].forEach(actionKey => {
//         Object.entries(groupedActions[actionKey]).sort(([,a], [,b]) => b.latestTime - a.latestTime).forEach(([, group]) => {
//           fpoeArray.push({
//             ...group.latestEntry,
//             actionType: actionKey === 'Like received' ? 'Likes received' : 
//                         actionKey === 'Like given' ? 'Likes given' : 
//                         actionKey === 'Comment received' ? 'Comments received' : 'Comments given',
//             actionDesc: actionKey === 'Like received' || actionKey === 'Like given' ? 'Compiled Likes' : 'Compiled Comments',
//             pointsAdded: group.totalPoints.toFixed(4),
//             fdate: group.latestEntry.fdate  // Keep full fdate for display
//           });
//         });
//       });

//       fpoeArray.push(...otherEntries);

//       // Final sort if needed (but groups and others are already time-sorted)
//       fpoeArray.sort((a, b) => new Date(b.fdate || '1970-01-01') - new Date(a.fdate || '1970-01-01'));

//       let dataListClone = fpoeArray.map((entry, index) => {
//         console.log('green dataListClone 2 ', entry.firstName);
//         nr = index + 1;
//         return [
//           nr,
//           entry.actionType ? entry.actionType : '',
//           entry.actionDesc ? entry.actionDesc.substring(0, 12) : '',
//           entry.title ? entry.title.substring(0, 12) : '',
//          // entry.fdate ? this.timeConverter(entry.fdate) : '',
//           entry.fdate ? this.normalizeDateToIdealFormat(entry.fdate) : '',
//           entry.gas ? this.formatLc(entry.gas) : '',
//           //entry.pointsCurrent ? this.formatLc(entry.pointsCurrent) : '',
//           entry.pointsCurrent ? this.formatLc(entry.pointsCurrent / 100) : '',
//           entry.pointsAdded ? this.formatLc(entry.pointsAdded, 4) : ''
//         ];
//       });
//       console.log('green dataListClone 3 ', dataListClone);
//       return dataListClone;
//     }
//     return [];
//   };

//   render() {
//     const { poe } = this.props
//     const getMuiTheme = () =>
//     createTheme({
//         overrides: {
//           MuiChip: {
//             root: {
//               backgroundColor: '#000000'
//             }
//           }
//         }
//       })

//     return (
//       <div>
//         <div><h3>Portfolio of Evidence</h3></div>
//         {/* {this.props.poe ? */}
//         <MuiThemeProvider theme={getMuiTheme()}>
//           <MUIDataTable
//             title={''}
//             data={this.transformTableData()}
//             columns={this.columns}
//             options={this.options}
//           // style={{id: "matrix"}}
//           />
//         </MuiThemeProvider>
//         {/* : null} */}
//       </div>
//     )
//   }
// }

// const mapStateToProps = (state, ownProps) => {
//   return {
//     userdata: state.userDialog.userDetails[0],
//     poe: state.poe.poe
//   }
// }

// const mapDispatchToProps = dispatch => {
//   return {
//     getPoe: params => dispatch(getPoe(params))
//     // showToast: params => dispatch(showToast(params))
//   }
// }

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(Poe)